/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Adds nested create feature
 * @export
 * @interface CustomQuestionnaireAnswerSetSource
 */
export interface CustomQuestionnaireAnswerSetSource {
  /**
   *
   * @type {number}
   * @memberof CustomQuestionnaireAnswerSetSource
   */
  readonly id: number;
  /**
   *
   * @type {number}
   * @memberof CustomQuestionnaireAnswerSetSource
   */
  answerSet: number;
  /**
   *
   * @type {number}
   * @memberof CustomQuestionnaireAnswerSetSource
   */
  questionnaire: number;
  /**
   *
   * @type {string}
   * @memberof CustomQuestionnaireAnswerSetSource
   */
  readonly questionnaireName: string;
}

/**
 * Check if a given object implements the CustomQuestionnaireAnswerSetSource interface.
 */
export function instanceOfCustomQuestionnaireAnswerSetSource(
  value: object,
): value is CustomQuestionnaireAnswerSetSource {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('answerSet' in value) || value['answerSet'] === undefined) return false;
  if (!('questionnaire' in value) || value['questionnaire'] === undefined) return false;
  if (!('questionnaireName' in value) || value['questionnaireName'] === undefined) return false;
  return true;
}

export function CustomQuestionnaireAnswerSetSourceFromJSON(json: any): CustomQuestionnaireAnswerSetSource {
  return CustomQuestionnaireAnswerSetSourceFromJSONTyped(json, false);
}

export function CustomQuestionnaireAnswerSetSourceFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CustomQuestionnaireAnswerSetSource {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    answerSet: json['answer_set'],
    questionnaire: json['questionnaire'],
    questionnaireName: json['questionnaireName'],
  };
}

export function CustomQuestionnaireAnswerSetSourceToJSON(
  value?: Omit<CustomQuestionnaireAnswerSetSource, 'id' | 'questionnaireName'> | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    answer_set: value['answerSet'],
    questionnaire: value['questionnaire'],
  };
}
